'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagDjAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.49757e-06 0L28 1.40592e-05C28 6.66668 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C5.87768e-07 13.3333 2.16321e-06 6.66667 1.49757e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V10H1.58697e-06L0 20Z",
          fill: "#1DC837"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.58697e-06 10H28V1.40592e-05L1.49757e-06 0L1.58697e-06 10Z",
          fill: "#82C5F5"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.49757e-06 0L13.3333 10L0 20L1.49757e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66667 11.3L2.70739 12.6967L3.4303 10.4017L1.49648 8.96996L3.90255 8.94829L4.66667 6.66668L5.43079 8.94829L7.83686 8.96996L5.90304 10.4017L6.62595 12.6967L4.66667 11.3Z",
          fill: "#E21C21"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 20L1.49757e-06 0L0.500002 0.367288L0.500002 19.6261L0 20Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagDjAsset = forwardRef(FlagDjAsset);

export { VpFlagDjAsset as default };
